import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintKelompokSasaran = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocKelompokSasaran = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            padding: "5px 0",
            textDecoration: "underline",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          <div>PERSYARATAN KELOMPOK SASARAN</div>
        </div>

        <div style={{ padding: "10px" }}>
          <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
            <tbody>
              <tr>
                <td rowSpan={3} style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                  No.
                </td>
                <td rowSpan={3} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                  Persyaratan
                </td>
                <td colSpan={3} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                  Kelompok Sasaran
                </td>
              </tr>
              <tr>
                <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>
                  Kawin
                </td>
                <td rowSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>
                  Lajang
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Suami</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Istri</td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>1</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Kartu Tanda Penduduk (KTP) elektronik atau resi kartu tanda penduduk elektronik</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>2</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Kartu Keluarga (KK)</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>3</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Akta Nikah</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>4</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Tidak memiliki rumah *</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>5</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Belum pernah menerima subsidi perolehan rumah berupa pemilikan rumah dari Pemerintah *</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>6</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Nomor Pokok Wajib Pajak (NPWP) **</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>7</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>SPT Tahunan PPh Orang Pribadi sesuai peraturan perundang-undangan ***</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>8</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Penghasilan tidak melebihi batas penghasilan yang ditentukan **</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>9</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Surat pemesanan rumah dari pengambang yang paling sedikit memuat harga jual rumah dan alamat rumah</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" }}>10</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Surat pernyataan Pemohon</td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
                <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              </tr>
            </tbody>
          </table>

          <p style={{ marginTop: "15px" }}>Catatan :</p>
          <div> ** berstatus kawin hanya dipersyaratkan suami/istri.</div>
          <div>*** dikecualikan untuk penghasilan dibawah PTKP.</div>
        </div>
      </div>
    </div>
  );
};
